import '../scss/skin.scss';
import '../images/armystar-logo-rb.svg';
import '../images/usace-logo-color.svg';
import '../images/250-year-logo-FINAL.png';
import configureSearch from './frontend/search';

document.addEventListener('DOMContentLoaded', () => {
  // Set up the search
  configureSearch();

  // Mobile Menu Trigger
  $(".mobile-menu-trigger").on('click', () => {
    $('body').toggleClass('menu-open');
  });

  //Search Trigger
  $("#search-form-trigger").on("click", (e) => {
    e.stopPropagation();
    $('body').toggleClass('search-open');
    $(".skin-search-input-ph").focus();
  });

  // Stop propogation of clicks on the search ui
  $('#main-search').on('click', (e) => {
    e.stopPropagation();
  });

  $(document).on("click", function (e) {
    if ($(e.currentTarget.activeElement).hasClass('usagov-search-autocomplete'))
      return true;
    $('body').removeClass('search-open');
  }
  );

  // Hot Info
  $('.box-banner').each(function () {
    var banner = $(this)
    banner.find('.more').click(function () {
      banner.addClass('open');
    });
    banner.find('.less').click(function () {
      banner.removeClass('open');
    });
  });

  // User profile menu
  $("#user-profile-link").popover({
    content: $("#user-meta-data"),
    html: true,
    trigger: 'focus',
    placement: 'bottom',
    template: '<div class="popover user-meta-popover" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>'
  });

  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      checkBanners();
    }, 100);
  });
  checkBanners();
  setTimeout(function () { configureSearch() }, 300);
});

function checkBanners() {
  $('.box-banner').each(function () {
    var content = $(this).find('.box-content')[0];
    if (content.clientWidth < content.scrollWidth) {
      $(this).addClass('on')
    } else {
      $(this).removeClass('on')
    }
  });
}

$(document).ready(function () {
    /**
    * Sets the class of the header based on the window scroll position
    */
    function calculateHeader() {
        var $header = $('#header-main');
        var y = window.pageYOffset;       
        if (y > 2) {
            $header.addClass('away-from-top');
        } else if (y < 2) {
            $header.removeClass('away-from-top');
        }
    }
    window.addEventListener("scroll", calculateHeader);
    calculateHeader();
}); //ready